import { Role } from "@collab/protocol";
import { ulid } from "ulid";
import { newEngagement } from "./engagement/machine.js";
import { Collection } from "./ports.js";
import { Expert } from "./router/keyword.js";
export const CardKind = {
    text: "text",
    saved: "saved",
    answer: "answer",
    draft: "draft",
    needsModel: "needs_model",
};
/** Engagements the agent opens from a chat question. */
const QUESTION_TOPIC = "question";
export async function runExpert(route, ports, contacts) {
    const now = ports.clock.now();
    switch (route.expert) {
        case Expert.remember: {
            const episode = { id: `ep_${ulid(now.getTime())}`, text: route.text, created_at: now.toISOString() };
            await ports.storage.put(Collection.episodes, episode.id, episode);
            return { kind: CardKind.saved, body: `Saved: "${route.text}"`, episode: episode.id };
        }
        case Expert.askSelf: {
            const episodes = await ports.storage.list(Collection.episodes);
            const hits = search(route.text, episodes).slice(0, 3);
            if (hits.length === 0)
                return { kind: CardKind.answer, body: "I have nothing saved about that.", sources: [] };
            const draft = await ports.model.generate(answerPrompt(route.text, hits));
            // Grounding rule: with no model we quote the notes; with one we still show which notes it used.
            const body = draft ?? hits.map((h) => `• ${h.text}`).join("\n");
            return { kind: CardKind.answer, body, sources: hits.map((h) => h.id) };
        }
        case Expert.askContact: {
            const contact = contacts.find((c) => c.name.toLowerCase() === route.contact?.toLowerCase());
            if (!contact)
                return { kind: CardKind.text, body: `I don't have ${route.contact} in your contacts yet.` };
            const engagement = newEngagement({
                role: Role.enum.requester,
                counterpart: contact.id,
                brief: { text: route.text, topic: QUESTION_TOPIC, shared: {} },
            }, now);
            await ports.storage.put(Collection.engagements, engagement.id, engagement);
            return { kind: CardKind.draft, body: `Ask ${contact.name}: "${route.text}"?`, engagement };
        }
        case Expert.setRule:
            return { kind: CardKind.text, body: `Rules come in M2. I understood: ${route.text}` };
        case Expert.find:
            return { kind: CardKind.text, body: `The marketplace comes in M3. I understood: ${route.text}` };
        default: {
            const reply = await ports.model.generate(route.text);
            return reply
                ? { kind: CardKind.text, body: reply }
                : {
                    kind: CardKind.needsModel,
                    body: "I need a model for that. Download one in Settings, or ask about your notes.",
                };
        }
    }
}
function search(query, episodes) {
    const words = query
        .toLowerCase()
        .split(/\W+/)
        .filter((w) => w.length > 2);
    return episodes
        .map((e) => ({ e, score: words.filter((w) => e.text.toLowerCase().includes(w)).length }))
        .filter((x) => x.score > 0)
        .sort((a, b) => b.score - a.score || b.e.created_at.localeCompare(a.e.created_at))
        .map((x) => x.e);
}
function answerPrompt(question, notes) {
    return [
        "Answer the owner's question using only these notes. If the notes do not answer it, say you don't know.",
        ...notes.map((n, i) => `Note ${i + 1}: ${n.text}`),
        `Question: ${question}`,
    ].join("\n");
}
//# sourceMappingURL=experts.js.map